import types from '../../../mutation-types';
import { isClientRecheckableFilter } from 'dashboard/helper/conversationHelper';

// Must match the backend page size (CONVERSATION_RESULTS_PER_PAGE / Kaminari default, both 25)
export const CONVERSATIONS_PER_PAGE = 25;

export const setPageFilter = ({ dispatch, filter, page, markEndReached }) => {
  dispatch('conversationPage/setCurrentPage', { filter, page }, { root: true });
  if (markEndReached) {
    dispatch('conversationPage/setEndReached', { filter }, { root: true });
  }
};

export const setContacts = (commit, chatList) => {
  commit(
    `contacts/${types.SET_CONTACTS}`,
    chatList.map(chat => chat.meta.sender)
  );
};

export const isOnMentionsView = ({ route: { name: routeName } }) => {
  const MENTION_ROUTES = [
    'conversation_mentions',
    'conversation_through_mentions',
  ];
  return MENTION_ROUTES.includes(routeName);
};

export const isOnUnattendedView = ({ route: { name: routeName } }) => {
  const UNATTENDED_ROUTES = [
    'conversation_unattended',
    'conversation_through_unattended',
  ];
  return UNATTENDED_ROUTES.includes(routeName);
};

export const isOnParallelRequestedView = ({ route: { name: routeName } }) => {
  const PARALLEL_ROUTES = [
    'conversation_parallel',
    'conversation_through_parallel',
  ];
  return PARALLEL_ROUTES.includes(routeName);
};

export const isOnFoldersView = ({ route: { name: routeName } }) => {
  const FOLDER_ROUTES = [
    'folder_conversations',
    'conversations_through_folders',
  ];
  return FOLDER_ROUTES.includes(routeName);
};

export const isOnServerScopedList = (state, rootState) => {
  if (isOnMentionsView(rootState) || isOnUnattendedView(rootState)) {
    return false;
  }
  const conditions = isOnFoldersView(rootState)
    ? rootState?.customViews?.activeConversationFolder?.query?.payload
    : state?.appliedFilters;
  if (isOnFoldersView(rootState) && !conditions) {
    return true;
  }
  return (conditions || []).some(filter => !isClientRecheckableFilter(filter));
};

export const buildConversationList = (
  context,
  requestPayload,
  responseData,
  filterType,
  { replace = false } = {}
) => {
  const { payload: conversationList, meta: metaData } = responseData;
  if (replace) {
    context.commit(types.REPLACE_ALL_CONVERSATIONS, conversationList);
  } else {
    context.commit(types.SET_ALL_CONVERSATION, conversationList);
  }
  context.dispatch('conversationStats/set', metaData);
  context.dispatch(
    'conversationLabels/setBulkConversationLabels',
    conversationList
  );
  context.commit(types.CLEAR_LIST_LOADING_STATUS);
  setContacts(context.commit, conversationList);
  setPageFilter({
    dispatch: context.dispatch,
    filter: filterType,
    page: requestPayload.page,
    markEndReached: conversationList.length < CONVERSATIONS_PER_PAGE,
  });
};
